// extracted by mini-css-extract-plugin
export default {"root":"FileTilesViewGridItemSkeleton_root__HSXsU","title":"FileTilesViewGridItemSkeleton_title__4FSF7"};